import React from 'react';

import { ImagesPageComponent } from '@bingads-webui-campaign-react/ads-studio-app-components';
import { notificationApi } from '../../adapters/get-notification';

export const ImagesPage = props => (
  <ImagesPageComponent {...props} notificationApi={notificationApi} />
);
